import { Grid } from '@mui/material';
import React from 'react';

const GuiaView = () => {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={12}></Grid>
    </Grid>
  );
};

export default GuiaView;
